module.exports = __webpack_public_path__ + "img/blog.84a76867.png";